function ctrl($scope, Global, $location, $state) {
    $scope.global = Global;
    $scope.select = function (url) {
        if ((url) && (url !== $location.$$url.replace('/',''))) {
            $scope.main.cleanup().then(function () {
                if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
                    // copy the time and strip out any other vars when clicking sidebar items
                    let time = angular.copy({ start: $location.$$search.start, end: $location.$$search.end });
                    $location.path(url).search(time);
                } else {
                    $location.path(url).search({});
                }
            })
        }
    };
    // this function allows us to hide sidebar elements based on what is defined in the sidebar array
    $scope.display = function (node) {
        var show = true;
        if (node.hasOwnProperty("hideAccess")) {
            show = node.hideAccess;
        }
        return show;
    };
    // Removed parentClass and updated nodeClass methods because I really hate hardcoded crap. Juan
    $scope.nodeClass = function (node, hasParent = false)
    {
        let currentUrl = $location.path().substring(1) || 'home';
        let hasChildren = (node.hasOwnProperty("children"));

        let containsUrl = function(curr_node = node)
        {
            if(curr_node.url == currentUrl)
                return true;

            if(curr_node.hasOwnProperty("orphans"))
            {
                for(let i = 0, len = curr_node.orphans.length; i < len; i++)
                {
                    if(curr_node.orphans[i] == currentUrl)
                        return true;
                }
            }

            if(curr_node.hasOwnProperty("children"))
            {
                for(let i = 0, len = curr_node.children.length; i < len; i++)
                {
                    if(containsUrl(curr_node.children[i]))
                        return true
                }
            }

            return false;
        };

        if (containsUrl())
        {
            if(!hasParent && !hasChildren)
                return "start active";

            if(!hasParent && hasChildren)
                return "start active open";

            if(hasParent && hasChildren)
                return "active open";

            if(hasParent && !hasChildren)
                return "active"
        }

        return "";
    };

    $scope.parentClassSelected = function (page)
    {
        var currentRoute = $location.path().substring(1) || 'home';

        return page === currentRoute ? 'selected' : '';
    };

    $scope.stealthLogo = function (link)
    {
        var currentRoute = $location.path().substring(1) || 'home';
        var url = require('../../../system/assets/img/stealth-logo.png');
        if (link.children.length > 0) {
            for (var i = 0, len = link.children.length; i < len; i++) {
                if (link.children[i].url === currentRoute) {
                    url = require('../../../system/assets/img/stealth-logo2.png');
                }
            };
        }
        return url;
    };
    ////////////////////////
    //// SUPPORT BUTTON ////
    ////////////////////////
    // even thought the support button is in the footer
    $scope.openSupportModal = function ()
    {
        location.href = "mailto:support@mantix4.com?Subject=Website Support Request";
    }

    var sideBarItems =
    [
        { // IOC NOTIFICATIONS
            'title': 'IOC Notifications',
            'url': false,
            'icon': 'fa-warning',
            'children':
            [
                {
                    'title': 'Outbound IOC',
                    'url': 'outbound_ioc',
                    'icon': 'fa-warning'
                    // 'hideAccess': [1], // if you'd like to limit access to a specific child instead
                },
                {
                    'title': 'Inbound IOC',
                    'url': 'inbound_ioc',
                    'icon': 'fa-warning'
                    // 'hideAccess': [1], // if you'd like to limit access to a specific child instead
                },
                {
                    'title': 'Lateral IOC',
                    'url': 'lateral_ioc',
                    'icon': 'fa-warning',
                    // 'hideAccess': [1], // if you'd like to limit access to a specific child instead
                },
		/*
                {
                    'title': 'Custom IOC',
                    'url': 'custom_ioc',
                    'iconreplace': true,
                    'icon': 'fa-blacklist'
                },
                {
                    'title': 'Whitelist',
                    'url': 'whitelist',
                    'iconreplace': true,
                    'icon': 'fa-whitelist'
                },
		*/
                // {
                //     'title': 'IOC Feeds',
                //     'url': 'ioc_feeds',
                //     'iconreplace': true,
                //     'icon': 'fa-blacklist'
                // },
                {
                    'title': 'AD Events',
                    'url': 'ad_events',
                    'hideAccess': $scope.global.user.settings_global.active_defense,
                    'iconreplace': true,
                    'icon': 'fa-active-defense',
                    'orphans': ['ad_events_drill']
                }/*,
                {
                    'title': 'cyr3con',
                    'url': 'cyr3con',
                    'hideAccess': $scope.global.user.settings_global.cyr3con,
                    'icon': 'fa-warning'
                }*/
            ]
        },
        { // Threat Hunting.
            'title': 'Threat Hunting',
            'hideAccess': $scope.global.user.settings_global.threat_hunting,
            'url': false,
            'icon': 'fa-eye',
            'children':
            [
                // Hide Hybrid Alerts until the page is finished
                // {
                //     'title': 'Hybrid Alerts',
                //     'url': 'hybrid_alerts',
                //     'icon': 'fa-exchange'
                // },
                /*{
                    'title': 'Attack Detection',
                    'url': false,
                    'iconreplace': true,
                    'icon': 'fa-active-defense',
                    'children': []
                },*/
                { // ANOMALIES
                    'title': 'Anomalies',
                    'url': false,
                    'icon': 'fa-asterisk',
                    'children':
                        [
                            // {
                            //     'title': 'New Local IPs',
                            //     'url': 'new_local_ip',
                            //     'icon': 'fa-exchange',
                            //     'orphans': []
                            // },
                            // {
                            //     'title': 'New Local MAC',
                            //     'url': 'new_local_mac',
                            //     'icon': 'fa-exchange',
                            //     'orphans': []
                            // },
                            {
                                'title': 'New Remote IPs',
                                'url': 'new_remote',
                                'icon': 'fa-exchange'
                            },
                            {
                                'title': 'New DNS Queries',
                                'url': 'new_dns_queries',
                                'icon': 'fa-info-circle'
                            },
                            {
                                'title': 'New HTTP Domains',
                                'url': 'new_http_domains',
                                'icon': 'fa-globe'
                            },
                            {
                                'title': 'New SSL Server Names',
                                'url': 'new_ssl_hosts',
                                'icon': 'fa-lock'
                            },
                            {
                                'title': 'New SSH Resp IPs',
                                'url': 'new_ssh_remote',
                                'icon': 'fa-lock'
                            },
                            {
                                'title': 'New FTP Resp IPs',
                                'url': 'new_ftp_remote',
                                'icon': 'fa-lock'
                            }
                        ]
                },
                {
                    'title': 'Tunnel Detection',
                    'url': false,
                    'icon': 'fa-exchange',
                    'children':
                    [
                        {
                            'title': 'Long Duration Conns',
                            'url': 'long_duration_conns',
                            'icon': 'fa-clock-o'
                        },
                        {
                            'title': 'DNS Exfil (UDP Tunnels)',
                            'url': 'dns_exfil_udp_tunnels',
                            'icon': 'fa-exchange'
                        },
                        /*{
                            'title': 'DNS Tunnel (DNScat2)',
                            'url': 'dns_tunnel_dnscat2',
                            'icon': 'fa-exchange'
                        },
                        {
                            'title': 'DNS Tunnel (Iodine-1)',
                            'url': 'dns_tunnel_iodine_1',
                            'icon': 'fa-exchange'
                        },
                        {
                            'title': 'DNS Tunnel (Iodine-2)',
                            'url': 'dns_tunnel_iodine_2',
                            'icon': 'fa-exchange'
                        }*/
                    ]
                },
                {
                    'title': 'Command & Control',
                    'url': false,
                    'icon': 'fa-desktop',
                    'children':
                    [
                        {
                            'title': 'Subdomain Stacking',
                            'url': 'dns_exfil_subdomains',
                            'icon': 'fa-globe'
                        },
                        {
                            'title': 'Large HTTP Responses',
                            'url': 'large_http_responses',
                            'icon': 'fa-download'
                        }/*,
                        {
                            'title': 'HTTP Beacons',
                            'url': 'http_beacons',
                            'iconreplace': true,
                            'icon': 'icon-broadcast'
                        },
                        {
                            'title': 'DNS Beacons',
                            'url': 'dns_beacons',
                            'iconreplace': true,
                            'icon': 'icon-broadcast'
                        }*/
                    ]
                },
                {
                    'title': 'Suspicious Hosts',
                    'url': false,
                    'icon': 'fa-search',
                    'children':
                    [
                        /*{
                            'title': 'Kaminsky DNS Attack',
                            'url': 'dns_poisoning',
                            'iconreplace': true,
                            'icon': 'fa-active-defense'
                        },*/
                        {
                            'title': 'Failed SSL Certificates',
                            'url': 'ssl_certs',
                            'icon': 'fa-lock'
                        },
                        {
                            'title': 'Top Internal Producers',
                            'url': 'top_internal_producers',
                            'icon': 'fa-info-circle'
                        },
                        {
                            'title': 'Non-Standard HTTP',
                            'url': 'non_standard_http',
                            'icon': 'fa-sitemap'
                        },
                        {
                            'title': 'User-Agents (HTTP)',
                            'url': 'user_agents',
                            'icon': 'fa-user'
                        }
                    ]
                },
                {
                    'title': 'Statistics',
                    'url': false,
                    'icon': 'fa-bar-chart-o',
                    'children':
                    [
                        {
                            'title': 'Top Responder Ports',
                            'url': 'top_responder_ports',
                            'icon': 'fa-bar-chart-o'
                        },
                        {
                            'title': 'Top Referred Hosts',
                            'url': 'top_referred_hosts',
                            'icon': 'fa-bar-chart-o'
                        },
                        {
                            'title': 'Most Popular Sites',
                            'url': 'most_popular_sites',
                            'icon': 'fa-bar-chart-o'
                        },
                        {
                            'title': 'Services Breakdown',
                            'url': 'services_breakdown',
                            'icon': 'fa-list-alt'
                        }
                    ]
                }
            ]
        },
        { // GENERAL NETWORK
            'title': 'General Network',
            'url': false,
            'icon': 'fa-sitemap',
            'children':
            [
                {
                    'title': 'Outbound Connections',
                    'url': 'outbound_resp_country',
                    'icon': 'fa-cloud-upload',
                    'orphans': ['outbound_resp','outbound_orig']
                },
                {
                    'title': 'Inbound Connections',
                    'url': 'inbound_resp',
                    'icon': 'fa-cloud-download',
                    'orphans': ['inbound_orig_country','inbound_orig']
                },
                {
                    'title': 'Lateral Connections',
                    'url': 'lateral_resp',
                    'icon': 'fa-cloud-upload',
                    'orphans': ['lateral_orig']
                },
                {
                    'title': 'Lateral Map',
                    'hideAccess': $scope.global.user.settings_global.network_map,
                    'url': 'lateral_map',
                    'icon': 'fa-code-fork'
                },
                {
                    'title': 'Services Map',
                    'url': 'services',
                    'icon': 'fa-code-fork',
                    'orphans': ['services']
                },
                {
                    'title': 'Network Assets',
                    'url': 'network_assets',
                    'icon': 'fa-user'
                },
            ]
        },
        { // STEALTH
            'title': 'Stealth',
            'hideAccess': $scope.global.user.settings_global.stealth,
            'url': false,
            'icon': 'fa-shield',
            'children':
            [
                {
                    'title': 'Stealth Deploy Config',
                    'url': 'stealth_deploy_config',
                    'icon': 'fa-code-fork'
                },
                {
                    'title': 'Stealth Ops View',
                    'url': 'stealth_op_view',
                    'icon': 'fa-shield'
                },
                {
                    'title': 'Stealth User Connections',
                    'url': 'stealth_conn',
                    'icon': 'fa-user',
                    'orphans': ['stealth_conn_orig']
                },
                {
                    'title': 'Stealth Events',
                    'url': 'stealth_events',
                    'icon': 'fa-desktop',
                    'orphans': ['stealth_events_orig']
                },
                // {
                //     'title': 'Stealth Connections Map',
                //     'url': 'stealth_network_map',
                //     'icon': 'fa-code-fork',
                //     'orphans': []
                // },
                //{
                //    'title': 'Stealth COI Connections',
                //    'url': 'stealth_coi_conn_view',
                //    'icon': 'fa-shield',
                //    'orphans': []
                //},
            ]
        },
        { // APPLICATIONS
            'title': 'Applications',
            'url': false,
            'icon': 'fa-bars',
            'children':
            [
                {
                    'title': 'L7 Applications',
                    'url': 'app_by_l7',
                    'icon': 'fa-bars',
                    'orphans': ['app_by_l7_resp', 'app_by_l7_resp_orig']
                },
                {
                    'title': 'DNS by Resolver',
                    'url': 'dns_by_resolver',
                    'icon': 'fa-level-down',
                    'orphans': ['dns_by_resolver_type', 'dns_by_type_resp_orig']
                },
                {
                    'title': 'DNS by Query Type',
                    'url': 'dns_by_type',
                    'icon': 'fa-level-down',
                    'orphans': ['dns_by_type_resp', 'dns_by_type_resp_orig']
                },
                {
                    'title': 'HTTP By Domain',
                    'url': 'http_by_domain',
                    'icon': 'fa-globe',
                    'orphans': ['http_by_domain_sub', 'http_by_domain_uri']
                },
                {
                    'title': 'SSL Server Name',
                    'url': 'ssl_by_server',
                    'icon': 'fa-lock',
                    'orphans': ['ssl_by_server_name', 'ssl_by_server_name_orig']
                },
                {
                    'title': 'FTP By Responder',
                    'url': 'ftp_resp',
                    'icon': 'fa-file',
                    'orphans': ['ftp_resp_orig']
                },
                {
                    'title': 'SSH Status',
                    'url': 'ssh_status',
                    'icon': 'fa-chevron-right',
                    'orphans': ['ssh_status_resp', 'ssh_status_resp_orig']
                },
            ]
        },
        { // FILES
            'title': 'Files Seen',
            'url': false,
            'icon': 'fa-folder',
            'children':
            [
                {
                    'title': 'Files By MIME',
                    'url': 'files_by_mime',
                    'icon': 'fa-folder-open',
                    'orphans': ['files_by_mime_type', 'files_by_mime_type_filename']
                },
            ]
        },
        { // SYSTEM EVENTS
            'title': 'System Events',
            'hideAccess': $scope.global.user.settings_global.system_events,
            'url': false,
            'icon': 'fa-user',
            'children':
            [
                {
                    'title': 'Endpoint By Type',
                    'url': 'endpoint_by_type',
                    'icon': 'fa-desktop',
                    'orphans': ['endpoint_by_type_and_user']
                },
                {
                    'title': 'Endpoint By Host',
                    'url': 'endpoint_by_user',
                    'icon': 'fa-desktop',
                    'orphans': ['endpoint_by_user_and_type']
                },
                {
                    'title': 'MS Events',
                    'url': 'endpoint_events_sharepoint',
                    'icon': 'fa-desktop',
                    'orphans': ['endpoint_events_sharepoint_drill']
                }
            ]
        },
        { // SEARCH
            'title': 'Search',
            'url': 'search',
            'icon': 'fa-search'
        },
    ];
    // if user is kiosk, simply remove all items from the sidebar that are not summary or the ioc_notifications
    if ($scope.global.user.user_level === 'kiosk') {
        var newList = [];
        for (var i = 0, len = sideBarItems.length; i < len; i++) {
            if ((sideBarItems[i].title === 'IOC Notifications') || (sideBarItems[i].title === 'Live Connections Dash')) {
                newList.push(sideBarItems[i]);
            }
        }
        sideBarItems = newList;
    }
    $scope.sideBarItems = sideBarItems;
};

ctrl.$inject = ['$scope', 'Global', '$location', '$state'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/main/sidebar.js
 **/